<template lang="pug">
  div.contenedor-lista
    h1.title Lista de reclamaciones
    .filtro-estados
      .option(
        v-for="o in estados"
        :class="{ 'fc-empresa': o === estado, 'selected': o === estado }"
        @click="estado = o"
      ) {{ o }}
    table.table.is-striped.is-bordered(
      v-if="lista.length !== 0"
    )
      thead
        th Numero
        th Local
        th Cliente
        th Fecha
        th Acciones
      tbody(
        name="table-row"
        is="transition-group"
      )
        tr.row-table(
          v-for="o in lista"
          :key="o.preimpreso"
        )
          td 
            span.name {{ o.preimpreso }}
          td 
            span {{ o.descripcionLocal }}
            br
            span.small {{ o.direccionLocal }}
          td 
            span {{ o.nombre }}
            br
            span.small {{ o.email }}
            br
            span.small {{ o.telefono }}
          td {{ o.fecha }}
          td.center.td-acciones
            button.button.bd-color-empresa.fc-empresa(
              @click="verPdf(o)"
            ) Ver detalles
            button.button.is-empresa.button-responder(
              v-if="o.estado === 1"
              @click="$emit('selected', o)"
            ) Responder
          
</template>

<script>
import { apiGet, notify } from '../util/general'
export default {
  name: 'lista-reclamaciones',
  data () {
    return {
      isLoading : true,
      lista: [],
      seleccionada: {},
      estado: 'pendientes',
      estados: [
        'pendientes',
        'respondidas',
        'todas'
      ]
    }
  },
  created () {
    this.fetch();
  },
  watch: {
    estado (value) {
      return this.fetch()
    }
  },
  methods: {
    seleccionar (o) {
      this.seleccionada = o
      this.$emit('selected', o)
    },
    fetch () {
      let vm = this

      var obj = {
        estado: vm.estado
      }
      apiGet(vm, '/libroreclamaciones/pendientes', obj, function (data) {
        vm.isLoading = false
        console.log('data:', data)
        vm.lista = data.lista
      }, function (error) {
        console.log(error);
        vm.isLoading = false
        notify(vm, 'error', 'Error', 'Problemas al obtener reclamaciones')
      })
    },
    verPdf (o) {
      var url = process.env.API_ROUTE + '/libroreclamaciones/pdf?empresa=' + process.env.EMPRESA + '&preimpreso=' + o.preimpreso + '&dni=' + o.dni
      console.log('url:', url)
      var link    = document.createElement('a');
      link.href   = url
      link.target = '_blank'
      link.click();
    }
  }
}
</script>
<style lang="stylus" scoped>
  .contenedor-lista
    text-align center
    
  .table
    font-size 13px

    th
      vertical-align: middle;
      text-align center
    td
      vertical-align: middle;
    
    td.center
      text-align center
    
    td
      .small
        font-size 12px
        color #9a9a9a
    
    .button-responder
      margin-left 5px
    
    .td-acciones
      width: 210px;
  
  h1.title
    margin-bottom: 5px;
  .filtro-estados
    display flex
    justify-content center
    margin-bottom: 15px;
    .option
      padding-left 5px
      cursor pointer
      text-transform: capitalize;
      &.selected
        font-weight bold
    
</style>



// WEBPACK FOOTER //
// Component-lista-reclamaciones.vue?096ad28f